/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useState } from "react";

import ReqEncrypt from "./components/RDAC/ReqEncrypt.js";
import { ThemeProvider } from "@mui/material";
import { theme } from "./AppStyles";
import { Toaster } from 'react-hot-toast';

import { getCookieUsuari } from "./security/tokenUtils.js";
import AuthRouter from "./serveis/router/AuthRouter.js";

export default function App() {
  const [user, setUser] = useState(getCookieUsuari());
  const [jsonData, setjsonData] = React.useState(null);
  const [location, setlocation] = React.useState(null);

  React.useEffect(() => {
    if (
      window.location.pathname === "/ModificarCoordenades" ||
      window.location.pathname === "/ConsultarDAs"
    ) {
      setlocation(window.location.search.substring(1));
      const urlWithoutQuery = window.location.origin + window.location.pathname;
      window.history.replaceState(null, null, urlWithoutQuery);
    }
  }, []);

  React.useEffect(() => {
    const cookieUsuari = getCookieUsuari();
    // Si el valor de la cookie ha cambiado, actualizamos el estado de user
    if (cookieUsuari !== user) {
      setUser(cookieUsuari);
    }
  }, [user]);

  return (
    <div>
      <Toaster />
      <ThemeProvider theme={theme}>
        {location !== null && location !== "" ? (
          <ReqEncrypt
            dataJSON={(dataJSON) => {
              setjsonData(dataJSON);
            }}
            missatge={location}
          />
        ) : null}
        <AuthRouter jsonData={jsonData} location={location}></AuthRouter>
      </ThemeProvider>
    </div>
  );
}
